import type { JSX } from 'react'
import { TargetSetup } from '@/settings/publish-target/TargetSetup'
import { may, useActiveTenant } from '@/tenant/context'
import { NoSiteYet, SettingsStepShell } from './SettingsStepShell'
import { useWizard } from './context'
import { useSettleStep } from './settingsStep'

/**
 * Step 13 — where approved articles go, through `/settings/publish-target`'s card.
 *
 * `onContinue` is what makes the step finishable when the target is already
 * connected — under Settings, or on an earlier visit whose `done` call failed.
 * The server also settles this step on its own once `sites.publish_target` is
 * set (`_reconcile`), so by the time the card reads *Connected* the rail
 * usually agrees; Continue is still the way to the next step from here.
 */
export function PublishTargetStep(): JSX.Element {
  const state = useWizard()
  const { membership } = useActiveTenant()
  const site = state.site ?? null
  const { settle, failure } = useSettleStep('publish_target')

  return (
    <SettingsStepShell step="publish_target" failure={failure}>
      {site === null ? (
        <NoSiteYet />
      ) : (
        <TargetSetup
          siteId={site.id}
          domain={site.domain}
          configurable={may(membership, 'tenant:update')}
          submitLabel="Continue"
          onSaved={() => {
            void settle()
          }}
          onContinue={() => {
            void settle()
          }}
        />
      )}
    </SettingsStepShell>
  )
}
